import { Typography } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'

export const PartnerPercentCell = ({ partner_percent, className = '' }) => (
  <Typography
    className={className}
    component={'span'}
    variant={'Body-15'}
    color={'Label-Fifth'}
  >
    {partner_percent}
  </Typography>
)
PartnerPercentCell.propTypes = {
  partner_percent: PropTypes.number,
  className: PropTypes.string,
}
